import { mapGetters } from 'vuex';

const INSURANCE_ATTR = 'insured_amt';
const LICENSE_TYPE = 'license';
const TOP_PRO = 'pro_badge_eligible';

export function asDictionary (attributes, keyKey, valueKey) {
  const dictionary = {};

  attributes.forEach((attribute) => {
    dictionary[attribute[keyKey]] = attribute[valueKey];
  });

  return dictionary;
}

const emptyObject = {};

export default {
  computed: {
    ...mapGetters('dashboard/publicProfile', [
      'getPublicProfileByServiceProviderIdentifier',
      'getPublicProfileByServiceProviderIdentifierAndOccupationId',
    ]),
    publicProfile () {
      return this.getPublicProfileByServiceProviderIdentifierAndOccupationId(
        this.serviceProviderUserIdentifier, this.serviceProviderOccupationId
      );
    },
    addressInfo () {
      if (!this.publicProfile) {
        return emptyObject;
      }

      return (this.publicProfile.service_provider.addresses || []).reduce(
        (acc, next) => ({ ...acc, [next.address_type]: next }),
        {}
      );
    },
    businessAddress () {
      return this.addressInfo.business;
    },
    licenseInfo () {
      if (!this.publicProfile) {
        return emptyObject;
      }

      const documents = this.publicProfile.documents || [];
      const licenseDocuments = documents.filter(
        document => document.document_type === LICENSE_TYPE
      );

      return {
        isLicensed: Boolean(licenseDocuments.length),
        licenses: licenseDocuments,
      };
    },
    insuranceInfo () {
      if (!this.publicProfile) {
        return emptyObject;
      }

      const attributeValues = asDictionary(
        this.publicProfile.service_provider.attribute_values || [],
        'service_provider_attribute',
        'value'
      );
      const insuredAmount = attributeValues[INSURANCE_ATTR] || 0;

      return {
        isInsured: Boolean(insuredAmount),
        amount: insuredAmount,
      };
    },
    topPro () {
      if (!this.publicProfile) {
        return null;
      }
      const attributeValues = asDictionary(
        this.publicProfile.service_provider.attribute_values || [],
        'service_provider_attribute',
        'value'
      );
      const topProAttr = attributeValues[TOP_PRO] || null;

      return topProAttr;
    },
  },
};
